var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { ActionTypes } from './actions';
export var initialState = {
    isLoading: false,
    data: null,
    error: null,
};
export var basket = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case ActionTypes.ADD_TO_BASKET:
            return __assign(__assign({}, state), { isLoading: true, data: null, error: null });
        case ActionTypes.ADD_TO_BASKET_SUCCESS:
            return __assign(__assign({}, state), { isLoading: false, data: action.payload.data });
        case ActionTypes.ADD_TO_BASKET_FAILURE:
            return __assign(__assign({}, state), { isLoading: false, error: action.payload.error });
        case ActionTypes.RESET_BASKET_ERROR:
            return __assign(__assign({}, state), { error: null });
        case ActionTypes.RESET_BASKET:
            return __assign({}, initialState);
        default:
            return state;
    }
};
